module.exports = __webpack_public_path__ + "img/back-body.7a1bc5b5.svg";